import React from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import { ExtraBalanceHeaderBottom } from '../styles/ExtraBalanceStyled';
import {
  ExtraBalanceVerifyfingTitleStyled as ExtraBalanceVerifyfingTitle,
  ExtraBalanceVerifyingContentStyled as ExtraBalanceVerifyingContent,
  ExtraBalanceVerifyingIconStyled as ExtraBalanceVerifyingIcon,
  ExtraBalanceVerifyingItemStyled as ExtraBalanceVerifyingItem,
  ExtraBalanceVerifyingWrapperStyled as ExtraBalanceVerifyingWrapper,
} from './styles/ExtraBalanceVerifyingStyled';

const duration = 0.3;
const variants = {
  initial: {
    opacity: 0,
    y: 10,
  },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration,
      delay: 0.5,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    y: 10,
    transition: {
      duration,
    },
  },
};
const ExtraBalanceVerifying = ({ conditions, loading }) => {
  const iconStatus = test => {
    if (loading) return 'loading';
    return test ? 'ok' : 'error';
  };

  const iconStatusClass = (test, item) => {
    const prefix = 'extra-balance-verify-condition-';
    if (loading) return `${prefix + item}-loading`;
    return test ? `${prefix + item}-pass` : `${prefix + item}-fail`;
  };

  return (
    <ExtraBalanceVerifyingWrapper>
      <ExtraBalanceHeaderBottom />
      <AnimatePresence>
        <motion.div
          key=""
          variants={variants}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          <ExtraBalanceVerifyingContent>
            <ExtraBalanceVerifyfingTitle id="extra-balance-verify-title">
              Validando tu Extra Saldo
            </ExtraBalanceVerifyfingTitle>
            <ul>
              <ExtraBalanceVerifyingItem id="extra-balance-verify-condition-one">
                <ExtraBalanceVerifyingIcon
                  id={iconStatusClass(conditions.hasRecharged, 'one')}
                  status={iconStatus(conditions.hasRecharged)}
                  data-testid={iconStatusClass(conditions.hasRecharged, 'one')}
                  alt="hasRecharged icon"
                />
                Debes haber realizado al menos una recarga durante los últimos
                30 días
              </ExtraBalanceVerifyingItem>
              <ExtraBalanceVerifyingItem id="extra-balance-verify-condition-two">
                <ExtraBalanceVerifyingIcon
                  id={iconStatusClass(!conditions.hasDebt, 'two')}
                  status={iconStatus(!conditions.hasDebt)}
                  data-testid={iconStatusClass(!conditions.hasDebt, 'two')}
                  alt="hasDebt icon"
                />
                Sin deuda de Extra Saldo vigente
              </ExtraBalanceVerifyingItem>
            </ul>
          </ExtraBalanceVerifyingContent>
        </motion.div>
      </AnimatePresence>
    </ExtraBalanceVerifyingWrapper>
  );
};

ExtraBalanceVerifying.propTypes = {
  conditions: PropTypes.shape({
    hasRecharged: PropTypes.bool,
    hasDebt: PropTypes.bool,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ExtraBalanceVerifying;
